var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 881 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edebe6;}.cls-2{fill:#fff;}.cls-3{mask:url(#mask);}.cls-4{mask:url(#mask-2);}.cls-5{fill:#ff5859;}.cls-6{fill:#ea444c;}.cls-7{fill:#fefeff;}.cls-8{fill:#a3a3aa;}.cls-9{fill:#626266;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 187.58,
    y: -7571,
    width: 225.21,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 306.39,
    y: -7571,
    width: 377.78,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.75,569.14c6.08,3.16,164.25-3.43,195.23,71.7s-63.93,129.83-63.93,129.83,38.23-28.34,50.09-.66c0,0,2.63-10.54,19.77-9.23S778,792.42,778,792.42s25-16.48,46.79,12.52H617.19l17.14-22.41L617.23,740s91.57-53,80.37-90.56-155.54-41.52-155.54-41.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.43,346.77c-36.91-137.07-281.16-103.68-376-93.14l7,15.82S661.34,229,635,341.49c-6.8,29-45.68,49.74-99.43,66.29l-3.81,50.27C625.23,432.93,696.35,398.47,682.43,346.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M531.21,458.68l3.89-51.26.31-.1c60.67-18.67,93.08-40.24,99.11-65.93,3.5-14.94.42-28-9.15-38.69-28.77-32.27-112-39.47-176.76-39.83a1273,1273,0,0,0-135.14,7.05l-.35,0-7.43-16.73.64-.07L318,251.85c49.82-5.65,133.19-15.12,207.19-6.53,89.36,10.38,142.44,44.46,157.75,101.32h0c6.52,24.23-5.35,46.48-35.27,66.13-25.34,16.66-63.21,31.62-115.76,45.74ZM536,408.13l-3.73,49.28c52.11-14,89.68-28.9,114.83-45.43,29.54-19.41,41.27-41.31,34.86-65.09h0c-15.19-56.44-68-90.3-156.93-100.62-73.89-8.57-157.2.88-207,6.53l-11,1.24,6.62,14.9a1275.66,1275.66,0,0,1,134.9-7c41.3.23,76.57,3.05,104.82,8.39,35.38,6.68,59.83,17.37,72.65,31.75,9.79,11,12.94,24.29,9.36,39.54C629.35,367.61,596.82,389.38,536,408.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.58,484.73v42.58c42.29-14.25,144.86-27.32,245.87-47V432.53C347.28,450,252,464.15,187.58,484.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.11,528v-43.6l.33-.1c45.88-14.66,106.19-25.86,170-37.72,25.09-4.65,51-9.47,75.87-14.49l.58-.12v48.72l-.39.08c-38.13,7.44-77.22,14.06-111.72,19.9C264,510.45,214,518.9,187.73,527.76Zm.95-42.9v41.57c26.52-8.81,76.18-17.22,133.6-26.94C356,493.89,395,487.3,433,479.89V433.12c-24.68,5-50.42,9.76-75.31,14.38C294,459.33,233.85,470.49,188.06,485.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.21,631.43c-36.9-84.34-514.86-47.44-523.64-89.62-1.07-5.13,6.3-9.88,20-14.5V484.73c-48,15.33-78.93,34.21-76.24,60.6,10.54,103.67,486.74,10.54,525.4,86.1s-52.72,110.7-151.12,109c0,0-8.79-31.63-45.69-26.36s-45.68,28.11-45.68,28.11S389,714,373.16,717.53s-24.6,19.33-24.6,19.33-8.79-21.08-26.36-10.54-21.09,26.36-21.09,26.36-22.84-22.85-35.14-12.3-15.81,19.33-15.81,19.33-35.15-38.66-72-22.85S135.94,772,135.94,772s-15.82-12.3-26.36-3.52S99,791.34,99,791.34s-35.15-14.06-54.48,7H640s15.12-20.15,5.48-17.57c0,0,5.28-28.11-31.63-28.11C613.89,752.68,728.11,715.78,691.21,631.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.21,631.43c-36.9-84.34-514.86-47.44-523.64-89.62-1.07-5.13,6.3-9.88,20-14.5V484.73c-48,15.33-78.93,34.21-76.24,60.6,10.54,103.67,486.74,10.54,525.4,86.1s-52.72,110.7-151.12,109c0,0-8.79-31.63-45.69-26.36s-45.68,28.11-45.68,28.11S389,714,373.16,717.53s-24.6,19.33-24.6,19.33-8.79-21.08-26.36-10.54-21.09,26.36-21.09,26.36-22.84-22.85-35.14-12.3-15.81,19.33-15.81,19.33-35.15-38.66-72-22.85S135.94,772,135.94,772s-15.82-12.3-26.36-3.52S99,791.34,99,791.34s-35.15-14.06-54.48,7l592.13-1.68s16.79-20.15,8.83-15.89c0,0,5.28-28.11-31.63-28.11C613.89,752.68,728.11,715.78,691.21,631.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.58,484.73v42.58C227,514,318.73,501.78,412.79,484.22l-4.91-46.65C328.9,452.8,245.71,466.17,187.58,484.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.43,346.77c-36.91-137.07-281.16-103.68-376-93.14l7,15.82S661.34,229,635,341.49c-7.51,32.05-54.11,54-116.68,71.32l-4.17,49.79C616.1,437.12,697.21,401.68,682.43,346.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,242.31h0A149.88,149.88,0,0,1,488.17,392.18V773.73a0,0,0,0,1,0,0H188.42a0,0,0,0,1,0,0V392.18A149.88,149.88,0,0,1,338.3,242.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "497.99 457.95 373.07 739.97 677.35 739.97 547.02 460.77 497.99 457.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "547.02 460.77 520.17 459.23 548.45 739.97 677.35 739.97 547.02 460.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M488.58,642.66c-7.83,0-14.85-.34-21-.87-32.71-2.81-49.85-11.44-50-11.53l.91-1.78c.17.09,17.06,8.57,49.43,11.33,29.89,2.55,79.47.61,145.89-23.11l.67,1.88C561.31,637.55,518.88,642.66,488.58,642.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.15,442a21.55,21.55,0,1,0-16,.23l-23.26,51,29.41-.41,3.75,0,30.74-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.43,346.77C656.07,248.87,523.93,237.93,416,243.51l-1.58,19.26c100.47-2.64,237.47,6.61,220.57,78.72-4.15,17.71-20.23,32.32-44.34,44.78,8.68,14.23,18.72,27.94,27.43,42.05C664.22,407,691.53,380.6,682.43,346.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M691.21,631.43c-10.51-16.32-46.48-34.3-89.77-44.95l24.3,63.8a40.22,40.22,0,0,1,6.55,9.59,33.94,33.94,0,0,1,3.82,17.64L656.4,730.8l-20.29-53.29c-2.39,35.43-65.82,64.38-150.49,62.87,0,0-15.16-39.67-47.23-34.85-36.86,5.52-44.14,36.6-44.14,36.6S389,714,373.16,717.53s-24.6,19.33-24.6,19.33-8.79-21.08-26.36-10.54-21.09,26.36-21.09,26.36-22.84-22.85-35.14-12.3-15.81,19.33-15.81,19.33-35.15-38.66-72-22.85S135.94,772,135.94,772s-15.82-12.3-26.36-3.52S99,791.34,99,791.34s-35.15-14.06-54.48,7L640,805.08s13.44-26.87,0-26.87c0,0,40.2-25,3.3-25C643.34,753.19,759.38,737.28,691.21,631.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.57,541.81c-1.07-5.13,6.31-9.87,20-14.49V484.73c-48,15.33-78.93,34.21-76.24,60.6,6.29,61.86,178.35,53.65,324.34,53L447.58,572C313.11,563.89,172.29,564.48,167.57,541.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "277.79 326.41 265.84 338.04 285.67 358.42 231.9 410.74 252.54 431.95 271.66 413.35 282.48 424.46 263.35 443.07 284 464.29 337.77 411.97 586.6 668.28 600.19 658.35 277.79 326.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "277.79 326.41 265.84 338.04 285.67 358.42 231.9 410.74 252.54 431.95 271.66 413.35 282.48 424.46 263.35 443.07 284 464.29 337.77 411.97 470 548.18 487.59 542.42 277.79 326.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "487.59 542.42 470 548.18 497.44 576.45 513.61 569.21 487.59 542.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "600.19 658.35 513.61 569.21 497.44 576.45 586.6 668.28 600.19 658.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "600.19 658.35 577.97 635.47 565.26 646.3 586.6 668.28 600.19 658.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M490.05,365.89c-22.56,32.38-44.52,65.84-41.51,66.85s28.2-8.55,28.2-8.55L424.36,528.75s97,2.73,132.53-95.64l5.29-35.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M556.49,434.51l30.33-6.7S577.77,468,556.49,434.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M601.53,204.49s-71.78,104.43-111.48,161.4l72.13,31.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.48,412.89a3.34,3.34,0,0,1-1.77-.5c-4.86-3,.21-18.2,1.28-21.21l1.8.64c-2.44,6.88-4.7,17.31-2.07,18.95a1.61,1.61,0,0,0,1.28.15c3.52-.83,9-8.62,10.79-11.55l1.62,1c-.71,1.15-7,11.25-12,12.4A4.05,4.05,0,0,1,503.48,412.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M554.07,448.9l2.2-14.35L531.58,469s3.36-21.46-19.67-33.83c-13.81-7.41-34.65-1.32-43.07,5.45L396.67,560.7S538.56,602,554.07,448.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "235 531.69 244.72 496.71 254.44 535.58 227.23 506.42 264.98 506.86 235 531.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "136.3 416.54 146.02 381.56 155.74 420.43 128.53 391.28 166.28 391.71 136.3 416.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "484.86 311.54 491.19 288.76 497.51 314.07 479.8 295.09 504.38 295.37 484.86 311.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "141.79 709.89 151.5 674.91 161.22 713.78 134.01 684.63 171.77 685.06 141.79 709.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "377.69 337.24 390.73 298.65 397.98 342.22 370.44 309.85 406.67 313.59 377.69 337.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "300.19 703.11 318.47 649.19 334.93 706.19 289.23 669.22 342.24 670.75 300.19 703.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M415.55,514.8l-50.71-47.27c-98.28,134.46-.19,180.64,46.91,186.23l18.08-39.68C312.36,592.11,406.89,526.54,415.55,514.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M415.55,514.8l-50.71-47.27c-98.28,134.46-.19,180.64,46.91,186.23l18.08-39.68C312.36,592.11,406.89,526.54,415.55,514.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M370.24,459.81s18.54-28.36,25.63-27.27,4.9,10.36,4.9,10.36,8.73-4.36,11.45.55a11.81,11.81,0,0,1,.55,9.82s9.27-1.64,11.45,1.63-.54,10.91-.54,10.91,7.63-3.82,9.81,1.09-22.36,30-22.36,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M573.42,621.35s-24,26.2-31.2,23.86-3.31-11.57-3.31-11.57-9.78,3-11.77-2.52a12.38,12.38,0,0,1,1.11-10.26s-9.88.11-11.58-3.65S519.1,606,519.1,606s-8.56,2.65-10-2.8,32.45-21.7,32.45-21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M580.31,658.55S514.61,719.63,570,774.19c36.67,36.11,93.88-31.48,93.88-31.48S738,684.36,695.66,631.56,580.31,658.55,580.31,658.55Zm98.56-11.17c8.41,10.48,10.75,21.25,9.62,31.44a31,31,0,0,1-37,26.84L636,702.51l3.45,22.89a30.88,30.88,0,0,1-15.73,31.83c-13,7-27.9,9.85-39.88-2-16.39-16.14-18.77-33-15.59-47.63a30.93,30.93,0,0,1,36.44-23.5l21.88,4.44L624,671.41c-4.62-30.63,33.9-48.7,54-25.14C678.26,646.63,678.57,647,678.87,647.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.59,514.48a77.85,77.85,0,0,0-11.5,4.54,51.17,51.17,0,0,0-10.36,6.57,31.2,31.2,0,0,0-4.3,4.3,19.87,19.87,0,0,0-3,5.18,16.5,16.5,0,0,0-1.14,5.81l.07,1.48c0,.5.14,1,.2,1.48a7.3,7.3,0,0,0,.89,2.69,13.57,13.57,0,0,0,4,4.24,34,34,0,0,0,5.16,3.11A77,77,0,0,0,168,558.29a206.16,206.16,0,0,0,24,5.54c16.22,3,32.64,4.81,49.08,6.42q12.33,1.21,24.69,2.1c8.23.68,16.48,1.19,24.73,1.74-8.27-.1-16.53-.42-24.79-.76s-16.52-.92-24.77-1.55-16.48-1.46-24.7-2.42-16.43-2.12-24.6-3.56A209.45,209.45,0,0,1,167.43,560a78.27,78.27,0,0,1-11.65-4.59,34.26,34.26,0,0,1-5.4-3.33,15.07,15.07,0,0,1-4.31-4.86,9.22,9.22,0,0,1-.65-1.55,9,9,0,0,1-.33-1.62c-.06-.54-.16-1.07-.19-1.6l0-1.62a17.83,17.83,0,0,1,1.36-6.25,24.94,24.94,0,0,1,7.88-9.77,51.87,51.87,0,0,1,10.76-6.29A70.05,70.05,0,0,1,176.59,514.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.41,502.67a150.53,150.53,0,0,0-14.65,6.62,107.64,107.64,0,0,0-13.69,8.32,52.09,52.09,0,0,0-11.53,10.88,24,24,0,0,0-3.57,6.92,16.37,16.37,0,0,0-.52,7.61,33.66,33.66,0,0,0,7,13.86,46.75,46.75,0,0,0,12.11,10A83.61,83.61,0,0,0,165,573.57,132.55,132.55,0,0,0,180.29,578c2.59.66,5.22,1.14,7.82,1.71s5.25,1,7.9,1.39l4,.62,4,.54c2.64.38,5.31.65,8,1,10.65,1.18,21.35,1.78,32.05,2.3s21.44.68,32.16.73,21.46,0,32.19-.1c-10.72.55-21.45.87-32.18,1.08s-21.48.12-32.22-.18-21.48-.93-32.19-2c-2.67-.3-5.35-.56-8-.92l-4-.52-4-.6c-2.67-.37-5.31-.91-8-1.36s-5.29-1-7.91-1.69a134.22,134.22,0,0,1-15.53-4.61,85.28,85.28,0,0,1-14.72-6.88A48.55,48.55,0,0,1,137.09,558a33.9,33.9,0,0,1-7.15-14.71,17.73,17.73,0,0,1,.7-8.28,25.24,25.24,0,0,1,3.89-7.25,52.67,52.67,0,0,1,12-10.92,106.89,106.89,0,0,1,14-8A132,132,0,0,1,175.41,502.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M644.59,313.91a52.26,52.26,0,0,1,2.8,6.8,67.39,67.39,0,0,1,2,7.09,64.82,64.82,0,0,1,1.7,14.7,55.73,55.73,0,0,1-2,14.73,49.48,49.48,0,0,1-6,13.62,60.17,60.17,0,0,1-9.64,11.35,73.75,73.75,0,0,1-5.84,4.6c-1,.7-2,1.46-3,2.11l-3.2,1.88c-.53.31-1.06.64-1.6.94l-1.65.82-3.32,1.64c-2.24,1-4.54,1.91-6.81,2.84-2.33.77-4.65,1.57-7,2.31s-4.74,1.28-7.11,1.89a121.89,121.89,0,0,0,26.69-11.78l3.07-1.94c1-.67,2-1.42,2.94-2.12,2-1.36,3.74-3.05,5.59-4.59a59.27,59.27,0,0,0,9.23-11,53.32,53.32,0,0,0,8.16-27.31,75.64,75.64,0,0,0-5-28.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M659.62,335.51a39.26,39.26,0,0,1,1.69,5.36,54.46,54.46,0,0,1,1.11,5.52,55.44,55.44,0,0,1,.55,11.3,53.53,53.53,0,0,1-1.78,11.23,49.34,49.34,0,0,1-4.28,10.56,52.74,52.74,0,0,1-14.94,17,72.51,72.51,0,0,1-19.91,10.4,91.88,91.88,0,0,0,19-11.63c1.47-1.13,2.78-2.43,4.15-3.66.68-.62,1.28-1.32,1.92-2a27.46,27.46,0,0,0,1.84-2.05,49.57,49.57,0,0,0,6.24-9,52.86,52.86,0,0,0,6.26-20.94,63.94,63.94,0,0,0,0-11.07A59.61,59.61,0,0,0,659.62,335.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M535.63,784.45c0-.17-2.85-17.36-12.57-21.78-9.44-4.28-21.17,12.63-21.29,12.8l-.74,1.07-.84-1c-.12-.13-11.32-13.11-24.15-20.44-12.22-7-31,18.93-31.18,19.2L442.94,777l.1-3.3c0-.61.33-14.83-14.51-16.58s-22.32,22.52-22.39,22.76l-.92,3.11-1-3.08c-.08-.23-7.51-22.76-25.29-21.84-7.47.37-13.53,3.19-18,8.39a23.71,23.71,0,0,0-4.55,7.79l-1.92-.57a25.25,25.25,0,0,1,4.89-8.46c3.34-3.9,9.43-8.65,19.49-9.15,15.46-.75,23.6,14.41,26.28,20.63a56.4,56.4,0,0,1,5-10.08c5.29-8.33,11.75-12.3,18.69-11.49,12.47,1.47,15.4,11.07,16.07,15.89,5-6.39,20.55-24.29,32.19-17.64,11.09,6.34,21,16.75,23.83,19.93,2.88-3.87,13.46-16.81,23-12.46,10.7,4.86,13.6,22.54,13.72,23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M253,786.25l-.81-1.48c0-.1-5.57-10-16.26-12.65-10.35-2.59-16.64,9.68-16.71,9.81l-1.44,2.87-.44-3.19c0-.2-3-20.08-21.82-25.46C180.56,751.87,173,767,169,775a20,20,0,0,1-2.5,4.33L165.06,778a22.9,22.9,0,0,0,2.12-3.8c4-8,12.33-24.65,28.9-19.92,15.92,4.54,21.18,18.74,22.7,24.57a27,27,0,0,1,3.56-4.26c4.26-4.09,9.13-5.6,14.08-4.36,9.17,2.29,14.68,9.26,16.68,12.25,3.57-5.32,15.76-22.43,23.77-19.74,7.11,2.37,12.78,12.58,14.82,16.69a38.26,38.26,0,0,1,5.17-6.37c5.11-4.94,10.26-6.21,14.91-3.68l-1,1.76c-9.35-5.1-18.27,10.71-18.36,10.87l-1,1.77-.81-1.85c-.07-.15-6.5-14.65-14.43-17.29-6.32-2.11-18.25,13.9-22.31,20.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 242.74,
    y: 645.34,
    width: 0.95,
    height: 52.59,
    transform: "translate(-11.95 4.45) rotate(-1.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 223.67,
    y: 674.44,
    width: 35.36,
    height: 0.95,
    transform: "translate(-120.87 56.4) rotate(-10.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 225.8,
    y: 671.62,
    width: 38.6,
    height: 0.95,
    transform: "translate(-422.5 415) rotate(-48.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 238.99,
    y: 655.45,
    width: 0.95,
    height: 33.3,
    transform: "translate(-378.66 315.76) rotate(-40.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 413.15,
    y: 365.55,
    width: 0.95,
    height: 53.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 399.51,
    y: 394.18,
    width: 25.42,
    height: 0.95,
    transform: "translate(-27.97 31.46) rotate(-4.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 396.52,
    y: 392.77,
    width: 35.16,
    height: 0.95,
    transform: "translate(-143.79 515.23) rotate(-55.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 412.68,
    y: 379.14,
    width: 0.95,
    height: 29.17,
    transform: "translate(-148.1 290.29) rotate(-33.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M671.13,493.83C648,445.43,578,476.72,558.86,486.25l15.59,34c13.06-8.81,45.73-28.28,57-11.31C645.76,530.3,545,573.69,545,573.69L583.87,622S698.08,550.12,671.13,493.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M733.21,663.65a42.54,42.54,0,0,1,.49,9,74.76,74.76,0,0,1-.91,8.95,89.24,89.24,0,0,1-4.89,17.32c-4.38,11.23-10.87,21.51-18.28,30.94a182.1,182.1,0,0,1-25.31,25.5A235.23,235.23,0,0,1,655,775.92a325.8,325.8,0,0,0,28.3-21.8l3.31-3c1.09-1,2.24-2,3.29-3,2.12-2.08,4.32-4.08,6.34-6.26l3.1-3.2,3-3.3,1.49-1.66,1.42-1.71c.94-1.14,1.91-2.27,2.83-3.43a130.72,130.72,0,0,0,18.41-30.27,95.38,95.38,0,0,0,5.37-16.92A60.28,60.28,0,0,0,733.21,663.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M780.71,759.72c-3.58-7.66-9.43-11.87-17.39-12.49a28.7,28.7,0,0,0-11,1.39l-.33-.9c.21-.07,20.7-7.5,29.61,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M720.59,593a99.92,99.92,0,0,1,28.57,19.41,82.7,82.7,0,0,1,11.19,13.34,71,71,0,0,1,7.88,15.58,66.51,66.51,0,0,1,3.37,17.15,67.59,67.59,0,0,1-1.26,17.39,96.94,96.94,0,0,1-13.17,31.92,108.75,108.75,0,0,0,11.7-32.19A67.13,67.13,0,0,0,766.43,642c-3.77-10.74-10.33-20.35-18.32-28.5a111.19,111.19,0,0,0-13-11.26A109,109,0,0,0,720.59,593Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.28,490.84a116.36,116.36,0,0,0-12,10.55,99.4,99.4,0,0,0-10.39,12.09,61.57,61.57,0,0,0-7.65,13.83,37.59,37.59,0,0,0-2.65,15.33,33.59,33.59,0,0,0,4.3,14.89,51.31,51.31,0,0,0,9.73,12.37,90,90,0,0,0,12.49,9.89c4.42,3,9.07,5.63,13.79,8.18-9.75-4.39-19.28-9.67-27.29-17a50.68,50.68,0,0,1-10.3-12.58,35.18,35.18,0,0,1-4.63-15.67,39,39,0,0,1,2.89-16.07,60.19,60.19,0,0,1,8.13-14.06A97.39,97.39,0,0,1,135.28,490.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.79,454.25q7.83-2,15.49-4.65T607.44,444a240.78,240.78,0,0,0,29.1-13.86c4.71-2.6,9.25-5.48,13.7-8.48s8.71-6.27,12.87-9.66l3.07-2.61,3-2.72c1-.89,2-1.84,2.91-2.79S674,402,674.89,401a132.31,132.31,0,0,0,10.38-12.38c-1.51,2.23-2.92,4.55-4.61,6.67-.83,1.07-1.6,2.18-2.47,3.22l-2.61,3.12a123.48,123.48,0,0,1-11.5,11.49,158.64,158.64,0,0,1-26.6,18.67q-7.11,4-14.49,7.39c-4.93,2.23-9.93,4.33-15,6.19A192.56,192.56,0,0,1,576.79,454.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637.34,444.16c3.6-2.38,7.16-4.83,10.61-7.42s6.88-5.19,10.22-7.9,6.62-5.51,9.76-8.44,6.25-5.9,9.14-9.07a122.74,122.74,0,0,0,8.25-9.84,85.41,85.41,0,0,0,6.84-10.83,52,52,0,0,0,4.58-11.93A40.89,40.89,0,0,0,697.89,366a38.25,38.25,0,0,1-.24,13,48.62,48.62,0,0,1-4.16,12.39,78.59,78.59,0,0,1-6.71,11.23,119.86,119.86,0,0,1-8.31,10.08A154.14,154.14,0,0,1,659.09,430,169.2,169.2,0,0,1,637.34,444.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M233,602.71q9.5.16,19,.5l18.94.66,18.93.63c6.32.16,12.63.34,19,.42a278.22,278.22,0,0,1-38,.86c-6.33-.24-12.65-.59-19-1.09S239.28,603.56,233,602.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M554.07,448.9l2.2-14.35L531.58,469s3.36-21.46-19.67-33.83c-13.81-7.41-34.65-1.32-43.07,5.45L396.67,560.7S538.56,602,554.07,448.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M591.23,616a8.16,8.16,0,0,1-4.52-1.26c-3.41-2.22-3.64-7.75-.67-16.46a83,83,0,0,1,3.41-8.35c-4.59,3.37-13,8.89-18.52,8.3a5.34,5.34,0,0,1-3.82-2c-2.46-3.14-1.53-8.74,2.76-16.65.49-.91,1-1.8,1.51-2.65-5.11,4.46-11.87,8.87-16.19,5.88-3.29-2.29-2.5-8.19,2.42-18a135,135,0,0,1,7.87-13.42.93.93,0,1,1,1.53,1c-6.49,9.54-15.15,25.83-10.76,28.88,5,3.48,16.55-7.79,20.58-12.42a.93.93,0,0,1,1.43,1.18c-4.06,5.23-13.7,19.92-9.7,25a3.56,3.56,0,0,0,2.57,1.32c6.88.77,20.2-10.25,20.34-10.36a.92.92,0,0,1,1.18,0,.94.94,0,0,1,.23,1.16c-3.26,6.05-10.53,22.52-5.16,26,6.58,4.27,18.87-6.83,19-6.94a.92.92,0,0,1,1.24,1.36C607.52,608,598.68,616,591.23,616Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 584.34,
    cy: 564.67,
    r: 2.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 601.42,
    cy: 585.05,
    r: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M395.57,533.12a.84.84,0,0,1-.43-.11.85.85,0,0,1-.3-1.16c3-5,10.29-19.19,8.69-24.41a2.33,2.33,0,0,0-1.23-1.54c-5.2-2.47-15.19,8.53-18.6,13a.85.85,0,0,1-1.37-1c3.35-4.93,11.11-18.59,6.82-22.52S372.42,501.5,368,505.69a.85.85,0,0,1-1.35-1c.07-.14,6.58-14.68,4.23-20.79a3.42,3.42,0,0,0-1.85-2.07c-6.8-3-17.52,8-17.63,8.09a.85.85,0,0,1-1.2,0,.86.86,0,0,1,0-1.2c.48-.49,11.65-11.92,19.53-8.46a5.12,5.12,0,0,1,2.75,3c1.86,4.84-1,13.77-2.86,18.67,5.17-4.38,15.84-12.33,20.71-7.89,3.74,3.42,1,11.14-2.06,17.08,4.43-4.38,10.42-8.9,14.8-6.82a4,4,0,0,1,2.12,2.57c2.14,7-8.4,25-8.85,25.77A.84.84,0,0,1,395.57,533.12Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 376.98,
    cy: 523.21,
    rx: 2.36,
    ry: 2.13,
    transform: "translate(-57.24 46.43) rotate(-6.55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 358.6,
    cy: 507.53,
    rx: 2.36,
    ry: 2.13,
    transform: "translate(-55.57 44.23) rotate(-6.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 373.92,
    y: 497.97,
    width: 149.24,
    height: 0.95,
    transform: "translate(-206.36 642.42) rotate(-60.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 396.29,
    y: 498.29,
    width: 146.18,
    height: 1.91,
    transform: "translate(-185.15 702.1) rotate(-63.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 407.69,
    y: 499.17,
    width: 143.89,
    height: 0.95,
    transform: "translate(-180.71 708.53) rotate(-63.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M491.11,553.2l-1.82-.57c1.3-4.18,31.84-102.58,32.88-105l1.75.75C523.12,450.23,502.11,517.76,491.11,553.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 492.98,
    y: 500.23,
    width: 65.43,
    height: 0.95,
    transform: "translate(-60.74 928.67) rotate(-79.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 507.54,
    y: 488.35,
    width: 56.65,
    height: 0.95,
    transform: "translate(-23.83 950.18) rotate(-81.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M479,446.13l38.38,17.72s-15.54,35.49-32.47,29.52C459.83,484.51,479,446.13,479,446.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490,480.31a6,6,0,0,1-2.7-.64c-7.32-3.66-2.92-19.4-2.73-20.07l1.84.52c-1.18,4.13-3.16,15.4,1.74,17.85s12-6.19,14.39-9.72l1.59,1.06C503.79,469.82,496.71,480.31,490,480.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M523.92,390.35H522c0-2.74-.76-4.66-2.27-5.7-3.19-2.19-8.77-.1-8.82-.08l-.69-1.78c.27-.1,6.57-2.47,10.58.28C522.87,384.49,523.92,386.94,523.92,390.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 307.57,
    y: 356.64,
    width: 1.91,
    height: 62.94,
    transform: "translate(-181.81 314.71) rotate(-43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M538.51,385.29s-11.26,24.6,15.43,34.14l2.86,15.25,5.72-37.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "600.92 207.47 518.97 378.65 562.18 397.73 600.92 207.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 279.15,
    y: 296.85,
    width: 0.95,
    height: 52.59,
    transform: "translate(-21.39 19.83) rotate(-3.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 260.23,
    y: 326.04,
    width: 35.35,
    height: 0.95,
    transform: "translate(-69.15 74.73) rotate(-13.64)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 262.22,
    y: 323.04,
    width: 38.6,
    height: 0.95,
    transform: "translate(-146.82 344.54) rotate(-51.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 275.42,
    y: 307.15,
    width: 0.95,
    height: 33.3,
    transform: "translate(-146.97 277.47) rotate(-43.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M551.32,383.92l-.51,0A5.1,5.1,0,0,1,547.2,382c-3.39-3.93-3.72-13.3-3.62-18.54-3.38,5.87-10.74,17-16.82,14.42-4.68-1.95-4.68-10.15-3.84-16.77-2.69,5.62-6.8,11.91-11.62,11.42a4,4,0,0,1-2.86-1.7c-4.39-5.87-.55-26.37-.39-27.24a.85.85,0,0,1,1.67.32c-1.09,5.72-3.2,21.53.07,25.9a2.36,2.36,0,0,0,1.68,1c5.75.54,11.41-13.16,13.12-18.5a.85.85,0,0,1,1-.55.83.83,0,0,1,.58,1c-1.48,5.78-4.17,21.26,1.2,23.5s13.66-11.42,16.43-16.87a.84.84,0,0,1,1-.43.85.85,0,0,1,.62.88c0,.16-1.23,16,3,21a3.46,3.46,0,0,0,2.45,1.32c7.41.54,13.79-13.43,13.85-13.57a.85.85,0,1,1,1.54.7C566.05,369.94,559.65,383.92,551.32,383.92Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 529.45,
    cy: 345.99,
    rx: 2.36,
    ry: 2.13,
    transform: "translate(-98.5 270.44) rotate(-26.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 552.05,
    cy: 354.53,
    rx: 2.36,
    ry: 2.13,
    transform: "translate(-99.94 281.34) rotate(-26.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M448.28,682a8.73,8.73,0,0,1-3-.57A5.2,5.2,0,0,1,442,677.9c-1.31-4.35,1.34-12.28,7.87-23.57,4.79-8.26,10-15.42,10.07-15.49l1.75-2.4.06,3c0,1.4.49,34.27-9.31,41.24A7,7,0,0,1,448.28,682Zm11.43-39.44c-6.42,9.22-17.92,27.8-15.83,34.75a3.26,3.26,0,0,0,2.1,2.24,5.36,5.36,0,0,0,5.27-.54c3.64-2.59,6.26-10.2,7.59-22C459.48,651.27,459.66,645.83,459.71,642.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M478.3,681.85a5.28,5.28,0,0,1-2.76-.81c-3.91-2.33-7.29-10-10.06-22.72-2-9.33-3-18.14-3-18.22l-.31-3,2,2.16c1,1,23.46,25,20.91,36.74a7.26,7.26,0,0,1-4.73,5.38A5.37,5.37,0,0,1,478.3,681.85ZM464.84,643c1.47,11.13,5.49,32.61,11.72,36.34a3.27,3.27,0,0,0,3.06.24,5.35,5.35,0,0,0,3.53-4c1-4.36-2.24-11.75-9.22-21.37C470.54,649.58,467,645.44,464.84,643Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.95fa1fa68468d164a674ce8488a3d665.svg";
export { ForwardRef as ReactComponent };